import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=e7f0a3b8&scoped=true&"
var script = {}
import style0 from "./Policy.vue?vue&type=style&index=0&id=e7f0a3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f0a3b8",
  null
  
)

export default component.exports